/* @flow */
import { ActionTypes } from '../constants/ExternalAccountResourceConstants';
import ExternalAccountResources from 'collections/ExternalAccountResources';
import ExternalAccountResource from 'entities/ExternalAccountResource';
import { dispatcher } from 'lib/Dispatcher';

const ExternalAccountResourceActions = {
  create() {
    return ExternalAccountResource.create(...arguments).then(externalAccountResource => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_BANK_ACCOUNT,
        externalAccountResource,
      });

      return externalAccountResource;
    });
  },

  makePrimary(account: ExternalAccountResource) {
    return account.makePrimary().then(externalAccountResource => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_PRIMARY_BANK_ACCOUNT,
        bankAccount: externalAccountResource.getBankAccount(),
      });
    });
  },

  delete(externalAccountResource: ExternalAccountResource) {
    return externalAccountResource.delete().then(() => {
      dispatcher.dispatch({
        type: ActionTypes.DELETE_BANK_ACCOUNT,
        bankAccount: externalAccountResource.getBankAccount(),
      });
    });
  },

  load() {
    return ExternalAccountResources.load().then(externalAccountResources => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_BANK_ACCOUNTS,
        externalAccountResources,
      });

      return externalAccountResources;
    });
  },
};

export default ExternalAccountResourceActions;



// WEBPACK FOOTER //
// ./src/payments/actions/ExternalAccountResourceActions.js